export var OrgUserRoles;
(function (OrgUserRoles) {
    OrgUserRoles["SUPER_ADMIN"] = "super";
    /** @deprecated Noop for permissions — use workspace roles instead. Kept only for DB storage backward compat. */
    OrgUserRoles["CREATOR"] = "org-level-creator";
    /** @deprecated Noop for permissions — use workspace roles instead. Kept only for DB storage backward compat. */
    OrgUserRoles["VIEWER"] = "org-level-viewer";
})(OrgUserRoles || (OrgUserRoles = {}));
/**
 * Enterprise org-level roles.
 *
 * ADMIN was originally named OWNER in cloud (stored as 'cloud-org-level-owner'
 * in the DB). Renamed to ADMIN because "Admin" better describes the role —
 * it's not a billing/subscription owner, it's an org administrator.
 *
 * OWNER is kept as a deprecated alias because cloud code references
 * CloudOrgUserRoles.OWNER in ~20 places. Both map to the same DB value.
 * New code should use ADMIN.
 */
export var EnterpriseOrgUserRoles;
(function (EnterpriseOrgUserRoles) {
    EnterpriseOrgUserRoles["ADMIN"] = "cloud-org-level-owner";
    /** @deprecated Use ADMIN — kept for cloud backward compat only */
    EnterpriseOrgUserRoles["OWNER"] = "cloud-org-level-owner";
    EnterpriseOrgUserRoles["CREATOR"] = "cloud-org-level-creator";
    EnterpriseOrgUserRoles["VIEWER"] = "cloud-org-level-viewer";
})(EnterpriseOrgUserRoles || (EnterpriseOrgUserRoles = {}));
/** @deprecated Use EnterpriseOrgUserRoles instead */
export const CloudOrgUserRoles = EnterpriseOrgUserRoles;
export var ProjectRoles;
(function (ProjectRoles) {
    ProjectRoles["OWNER"] = "owner";
    ProjectRoles["CREATOR"] = "creator";
    ProjectRoles["INHERIT"] = "inherit";
    ProjectRoles["EDITOR"] = "editor";
    ProjectRoles["COMMENTER"] = "commenter";
    ProjectRoles["VIEWER"] = "viewer";
    ProjectRoles["NO_ACCESS"] = "no-access";
})(ProjectRoles || (ProjectRoles = {}));
export var WorkspaceUserRoles;
(function (WorkspaceUserRoles) {
    WorkspaceUserRoles["OWNER"] = "workspace-level-owner";
    WorkspaceUserRoles["CREATOR"] = "workspace-level-creator";
    WorkspaceUserRoles["INHERIT"] = "workspace-level-inherit";
    WorkspaceUserRoles["EDITOR"] = "workspace-level-editor";
    WorkspaceUserRoles["COMMENTER"] = "workspace-level-commenter";
    WorkspaceUserRoles["VIEWER"] = "workspace-level-viewer";
    WorkspaceUserRoles["NO_ACCESS"] = "workspace-level-no-access";
})(WorkspaceUserRoles || (WorkspaceUserRoles = {}));
export var TeamUserRoles;
(function (TeamUserRoles) {
    TeamUserRoles["MEMBER"] = "member";
    TeamUserRoles["OWNER"] = "owner";
})(TeamUserRoles || (TeamUserRoles = {}));
export var AppEvents;
(function (AppEvents) {
    AppEvents["PROJECT_CREATE"] = "base.create";
    AppEvents["PROJECT_INVITE"] = "base.invite";
    AppEvents["PROJECT_USER_UPDATE"] = "base.user.update";
    AppEvents["PROJECT_USER_RESEND_INVITE"] = "base.user.resend.invite";
    AppEvents["PROJECT_TEAM_INVITE"] = "base.team.invite";
    AppEvents["PROJECT_TEAM_UPDATE"] = "base.team.update";
    AppEvents["PROJECT_TEAM_DELETE"] = "base.team.delete";
    AppEvents["PROJECT_DELETE"] = "base.delete";
    AppEvents["PROJECT_UPDATE"] = "base.update";
    AppEvents["PROJECT_CLONE"] = "base.clone";
    AppEvents["WELCOME"] = "app.welcome";
    AppEvents["WORKSPACE_USER_INVITE"] = "workspace.invite";
    AppEvents["WORKSPACE_USER_UPDATE"] = "workspace.user.update";
    AppEvents["WORKSPACE_USER_DELETE"] = "workspace.user.delete";
    AppEvents["WORKSPACE_TEAM_INVITE"] = "workspace.team.invite";
    AppEvents["WORKSPACE_TEAM_UPDATE"] = "workspace.team.update";
    AppEvents["WORKSPACE_TEAM_DELETE"] = "workspace.team.delete";
    AppEvents["WORKSPACE_CREATE"] = "workspace.create";
    AppEvents["WORKSPACE_DELETE"] = "workspace.delete";
    AppEvents["WORKSPACE_UPDATE"] = "workspace.update";
    AppEvents["WORKSPACE_UPGRADE_REQUEST"] = "workspace.upgrade.request";
    AppEvents["SCIM_USER_PROVISION"] = "scim.user.provision";
    AppEvents["SCIM_USER_UPDATE"] = "scim.user.update";
    AppEvents["SCIM_USER_DEACTIVATE"] = "scim.user.deactivate";
    AppEvents["SCIM_USER_REACTIVATE"] = "scim.user.reactivate";
    AppEvents["SCIM_USER_DELETE"] = "scim.user.delete";
    AppEvents["SCIM_GROUP_PROVISION"] = "scim.group.provision";
    AppEvents["SCIM_GROUP_UPDATE"] = "scim.group.update";
    AppEvents["SCIM_GROUP_REPLACE"] = "scim.group.replace";
    AppEvents["SCIM_GROUP_DELETE"] = "scim.group.delete";
    AppEvents["SCIM_CONFIG_CREATE"] = "scim.config.create";
    AppEvents["SCIM_CONFIG_UPDATE"] = "scim.config.update";
    AppEvents["SCIM_CONFIG_DISABLE"] = "scim.config.disable";
    AppEvents["SCIM_CONFIG_DELETE"] = "scim.config.delete";
    AppEvents["SCIM_CONFIG_TOKEN_REGENERATE"] = "scim.config.token.regenerate";
    AppEvents["SSO_CLIENT_CREATE"] = "sso.client.create";
    AppEvents["SSO_CLIENT_UPDATE"] = "sso.client.update";
    AppEvents["SSO_CLIENT_DELETE"] = "sso.client.delete";
    AppEvents["ORG_DOMAIN_ADD"] = "org.domain.add";
    AppEvents["ORG_DOMAIN_UPDATE"] = "org.domain.update";
    AppEvents["ORG_DOMAIN_DELETE"] = "org.domain.delete";
    AppEvents["ORG_DOMAIN_VERIFY"] = "org.domain.verify";
    AppEvents["USER_SIGNUP"] = "user.signup";
    AppEvents["USER_SIGNIN"] = "user.signin";
    AppEvents["USER_SIGNIN_FAILED"] = "user.signin.failed";
    AppEvents["USER_INVITE"] = "user.invite";
    AppEvents["USER_UPDATE"] = "user.update";
    AppEvents["USER_PASSWORD_RESET"] = "user.password.reset";
    AppEvents["USER_PASSWORD_CHANGE"] = "user.password.change";
    AppEvents["USER_PASSWORD_FORGOT"] = "user.password.forgot";
    AppEvents["USER_DELETE"] = "user.delete";
    AppEvents["USER_EMAIL_VERIFICATION"] = "user.email.verification";
    AppEvents["USER_MFA_SETUP"] = "user.mfa.setup";
    AppEvents["USER_MFA_ENABLED"] = "user.mfa.enabled";
    AppEvents["USER_MFA_DISABLED"] = "user.mfa.disabled";
    AppEvents["USER_MFA_VERIFY"] = "user.mfa.verify";
    AppEvents["USER_MFA_BACKUP_CODE_USED"] = "user.mfa.backup.code.used";
    AppEvents["TEAM_CREATE"] = "team.create";
    AppEvents["TEAM_UPDATE"] = "team.update";
    AppEvents["TEAM_DELETE"] = "team.delete";
    AppEvents["TEAM_MEMBER_ADD"] = "team.member.add";
    AppEvents["TEAM_MEMBER_UPDATE"] = "team.member.update";
    AppEvents["TEAM_MEMBER_DELETE"] = "team.member.delete";
    AppEvents["TEAM_MOVE"] = "team.move";
    AppEvents["TABLE_CREATE"] = "table.create";
    AppEvents["TABLE_DELETE"] = "table.delete";
    AppEvents["TABLE_UPDATE"] = "table.update";
    AppEvents["VIEW_CREATE"] = "view.create";
    AppEvents["VIEW_DELETE"] = "view.delete";
    AppEvents["VIEW_UPDATE"] = "view.update";
    AppEvents["SHARED_VIEW_CREATE"] = "shared.view.create";
    AppEvents["SHARED_VIEW_DELETE"] = "shared.view.delete";
    AppEvents["SHARED_VIEW_UPDATE"] = "shared.view.update";
    AppEvents["FILTER_CREATE"] = "filter.create";
    AppEvents["FILTER_DELETE"] = "filter.delete";
    AppEvents["FILTER_UPDATE"] = "filter.update";
    AppEvents["SORT_CREATE"] = "sort.create";
    AppEvents["SORT_DELETE"] = "sort.delete";
    AppEvents["SORT_UPDATE"] = "sort.update";
    AppEvents["COLUMN_CREATE"] = "column.create";
    AppEvents["COLUMN_DELETE"] = "column.delete";
    AppEvents["COLUMN_UPDATE"] = "column.update";
    AppEvents["DATA_CREATE"] = "data.create";
    AppEvents["DATA_DELETE"] = "data.delete";
    AppEvents["DATA_UPDATE"] = "data.update";
    AppEvents["ORG_USER_INVITE"] = "org.user.invite";
    AppEvents["ORG_USER_RESEND_INVITE"] = "org.user.resend.invite";
    AppEvents["ORG_USER_UPDATE"] = "org.user.update";
    AppEvents["ORG_USER_DELETE"] = "org.user.delete";
    AppEvents["ORG_USER_ADD"] = "org.user.add";
    AppEvents["ORG_USER_REMOVE"] = "org.user.remove";
    AppEvents["ORG_WORKSPACE_ADD"] = "org.workspace.add";
    AppEvents["ORG_WORKSPACE_REMOVE"] = "org.workspace.remove";
    AppEvents["VIEW_COLUMN_CREATE"] = "view.column.create";
    AppEvents["VIEW_COLUMN_UPDATE"] = "view.column.update";
    AppEvents["API_TOKEN_CREATE"] = "api.token.create";
    AppEvents["API_TOKEN_DELETE"] = "api.token.delete";
    AppEvents["API_TOKEN_UPDATE"] = "api.token.update";
    AppEvents["IMAGE_UPLOAD"] = "image.upload";
    AppEvents["FORM_COLUMN_UPDATE"] = "form.column.update";
    AppEvents["FORM_CREATE"] = "form.create";
    AppEvents["FORM_UPDATE"] = "form.update";
    AppEvents["GALLERY_CREATE"] = "gallery.create";
    AppEvents["GALLERY_UPDATE"] = "gallery.update";
    AppEvents["MAP_CREATE"] = "map.create";
    AppEvents["MAP_UPDATE"] = "map.update";
    AppEvents["MAP_DELETE"] = "map.delete";
    AppEvents["KANBAN_CREATE"] = "kanban.create";
    AppEvents["KANBAN_UPDATE"] = "kanban.update";
    AppEvents["META_DIFF_SYNC"] = "meta.diff.sync";
    AppEvents["GRID_CREATE"] = "grid.create";
    AppEvents["GRID_UPDATE"] = "grid.update";
    AppEvents["GRID_COLUMN_UPDATE"] = "grid.column.update";
    AppEvents["WEBHOOK_CREATE"] = "webhook.create";
    AppEvents["WEBHOOK_UPDATE"] = "webhook.update";
    AppEvents["WEBHOOK_DELETE"] = "webhook.delete";
    AppEvents["WEBHOOK_TEST"] = "webhook.test";
    AppEvents["WEBHOOK_TRIGGER"] = "webhook.trigger";
    AppEvents["UI_ACL_UPDATE"] = "ui.acl.update";
    AppEvents["ORG_API_TOKEN_CREATE"] = "org.api.token.create";
    AppEvents["ORG_API_TOKEN_DELETE"] = "org.api.token.delete";
    AppEvents["ORG_API_TOKEN_UPDATE"] = "org.api.token.update";
    AppEvents["PLUGIN_TEST"] = "plugin.test";
    AppEvents["PLUGIN_INSTALL"] = "plugin.install";
    AppEvents["PLUGIN_UNINSTALL"] = "plugin.uninstall";
    AppEvents["SYNC_SOURCE_CREATE"] = "sync.source.create";
    AppEvents["SYNC_SOURCE_UPDATE"] = "sync.source.update";
    AppEvents["SYNC_SOURCE_DELETE"] = "sync.source.delete";
    AppEvents["RELATION_DELETE"] = "relation.delete";
    AppEvents["RELATION_CREATE"] = "relation.create";
    AppEvents["SHARED_BASE_GENERATE_LINK"] = "shared.base.generate.link";
    AppEvents["SHARED_BASE_DELETE_LINK"] = "shared.base.delete.link";
    AppEvents["ATTACHMENT_UPLOAD"] = "attachment.upload";
    AppEvents["APIS_CREATED"] = "apis.created";
    AppEvents["EXTENSION_CREATE"] = "extension.create";
    AppEvents["EXTENSION_UPDATE"] = "extension.update";
    AppEvents["EXTENSION_DELETE"] = "extension.delete";
    AppEvents["COMMENT_CREATE"] = "comment.create";
    AppEvents["COMMENT_DELETE"] = "comment.delete";
    AppEvents["COMMENT_UPDATE"] = "comment.update";
    AppEvents["INTEGRATION_DELETE"] = "integration.delete";
    AppEvents["INTEGRATION_CREATE"] = "integration.create";
    AppEvents["INTEGRATION_UPDATE"] = "integration.update";
    AppEvents["ROW_USER_MENTION"] = "row.user.mention";
    AppEvents["CALENDAR_CREATE"] = "calendar.create";
    AppEvents["TIMELINE_CREATE"] = "timeline.create";
    AppEvents["FORM_DUPLICATE"] = "form.duplicate";
    AppEvents["CALENDAR_UPDATE"] = "calendar.update";
    AppEvents["TIMELINE_UPDATE"] = "timeline.update";
    AppEvents["CALENDAR_DELETE"] = "calendar.delete";
    AppEvents["TIMELINE_DELETE"] = "timeline.delete";
    AppEvents["GANTT_CREATE"] = "gantt.create";
    AppEvents["GANTT_UPDATE"] = "gantt.update";
    AppEvents["GANTT_DELETE"] = "gantt.delete";
    AppEvents["FORM_DELETE"] = "form.delete";
    AppEvents["SOURCE_CREATE"] = "source.create";
    AppEvents["SOURCE_UPDATE"] = "source.update";
    AppEvents["SOURCE_DELETE"] = "source.delete";
    AppEvents["SHARED_BASE_REVOKE_LINK"] = "shared.base.revoke.link";
    AppEvents["GRID_DELETE"] = "grid.delete";
    AppEvents["GRID_DUPLICATE"] = "grid.duplicate";
    AppEvents["KANBAN_DELETE"] = "kanban.delete";
    AppEvents["KANBAN_DUPLICATE"] = "kanban.duplicate";
    AppEvents["GALLERY_DELETE"] = "gallery.delete";
    AppEvents["GALLERY_DUPLICATE"] = "gallery.duplicate";
    AppEvents["LIST_CREATE"] = "list.create";
    AppEvents["LIST_UPDATE"] = "list.update";
    AppEvents["LIST_DELETE"] = "list.delete";
    AppEvents["BASE_DUPLICATE_START"] = "base.duplicate.start";
    AppEvents["BASE_DUPLICATE_COMPLETE"] = "base.duplicate.complete";
    AppEvents["BASE_DUPLICATE_FAIL"] = "base.duplicate.fail";
    AppEvents["TABLE_DUPLICATE_START"] = "table.duplicate.start";
    AppEvents["TABLE_DUPLICATE_COMPLETE"] = "table.duplicate.complete";
    AppEvents["TABLE_DUPLICATE_FAIL"] = "table.duplicate.fail";
    AppEvents["COLUMN_DUPLICATE_START"] = "column.duplicate.start";
    AppEvents["COLUMN_DUPLICATE_COMPLETE"] = "column.duplicate.complete";
    AppEvents["COLUMN_DUPLICATE_FAIL"] = "column.duplicate.fail";
    AppEvents["VIEW_DUPLICATE_START"] = "view.duplicate.start";
    AppEvents["VIEW_DUPLICATE_COMPLETE"] = "view.duplicate.complete";
    AppEvents["VIEW_DUPLICATE_FAIL"] = "view.duplicate.fail";
    AppEvents["USER_SIGNOUT"] = "user.signout";
    AppEvents["PROJECT_USER_DELETE"] = "base.user.delete";
    AppEvents["UI_ACL"] = "model.role.ui.acl";
    AppEvents["SNAPSHOT_CREATE"] = "snapshot.create";
    AppEvents["SNAPSHOT_DELETE"] = "snapshot.delete";
    AppEvents["SNAPSHOT_RESTORE"] = "snapshot.restore";
    AppEvents["DATA_EXPORT"] = "data.export";
    AppEvents["DATA_IMPORT"] = "data.import";
    AppEvents["USER_PROFILE_UPDATE"] = "user.profile.update";
    AppEvents["SCRIPT_CREATE"] = "script.create";
    AppEvents["SCRIPT_DELETE"] = "script.delete";
    AppEvents["SCRIPT_UPDATE"] = "script.update";
    AppEvents["SCRIPT_DUPLICATE"] = "script.duplicate";
    AppEvents["DASHBOARD_CREATE"] = "dashboard.create";
    AppEvents["DASHBOARD_UPDATE"] = "dashboard.update";
    AppEvents["DASHBOARD_DELETE"] = "dashboard.delete";
    AppEvents["SHARED_DASHBOARD_GENERATE_LINK"] = "shared.dashboard.generate.link";
    AppEvents["SHARED_DASHBOARD_UPDATE_LINK"] = "shared.dashboard.update.link";
    AppEvents["SHARED_DASHBOARD_DELETE_LINK"] = "shared.dashboard.delete.link";
    AppEvents["DASHBOARD_DUPLICATE_START"] = "dashboard.duplicate.start";
    AppEvents["DASHBOARD_DUPLICATE_COMPLETE"] = "dashboard.duplicate.complete";
    AppEvents["DASHBOARD_DUPLICATE_FAIL"] = "dashboard.duplicate.fail";
    AppEvents["WIDGET_CREATE"] = "widget.create";
    AppEvents["WIDGET_UPDATE"] = "widget.update";
    AppEvents["WIDGET_DELETE"] = "widget.delete";
    AppEvents["WIDGET_DUPLICATE"] = "widget.duplicate";
    AppEvents["PERMISSION_CREATE"] = "permission.create";
    AppEvents["PERMISSION_UPDATE"] = "permission.update";
    AppEvents["PERMISSION_DELETE"] = "permission.delete";
    AppEvents["WORKFLOW_CREATE"] = "workflow.create";
    AppEvents["WORKFLOW_UPDATE"] = "workflow.update";
    AppEvents["WORKFLOW_DELETE"] = "workflow.delete";
    AppEvents["WORKFLOW_DUPLICATE"] = "workflow.duplicate";
    AppEvents["WORKFLOW_EXECUTE"] = "workflow.execute";
    AppEvents["BOOKMARK_CREATE"] = "bookmark.create";
    AppEvents["BOOKMARK_DELETE"] = "bookmark.delete";
    AppEvents["BOOKMARK_MOVE"] = "bookmark.move";
    AppEvents["BOOKMARK_GROUP_CREATE"] = "bookmark.group.create";
    AppEvents["BOOKMARK_GROUP_DELETE"] = "bookmark.group.delete";
    AppEvents["SANDBOX_CREATE"] = "sandbox.create";
    AppEvents["SANDBOX_DELETE"] = "sandbox.delete";
    AppEvents["SANDBOX_DISCARD"] = "sandbox.discard";
    AppEvents["SANDBOX_MERGE"] = "sandbox.merge";
    AppEvents["RECORD_TEMPLATE_CREATE"] = "record.template.create";
    AppEvents["RECORD_TEMPLATE_UPDATE"] = "record.template.update";
    AppEvents["RECORD_TEMPLATE_DELETE"] = "record.template.delete";
    AppEvents["RECORD_TEMPLATE_USE"] = "record.template.use";
    AppEvents["RLS_POLICY_CREATE"] = "rls_policy.create";
    AppEvents["RLS_POLICY_UPDATE"] = "rls_policy.update";
    AppEvents["RLS_POLICY_DELETE"] = "rls_policy.delete";
    AppEvents["VIEW_SECTION_CREATE"] = "viewSection.create";
    AppEvents["VIEW_SECTION_UPDATE"] = "viewSection.update";
    AppEvents["VIEW_SECTION_DELETE"] = "viewSection.delete";
    AppEvents["CHAT_SESSION_CREATE"] = "chat.session.create";
    AppEvents["CHAT_SESSION_UPDATE"] = "chat.session.update";
    AppEvents["CHAT_SESSION_DELETE"] = "chat.session.delete";
    AppEvents["CHAT_MESSAGE_CREATE"] = "chat.message.create";
    AppEvents["CHAT_TOOL_EXECUTE"] = "chat.tool.execute";
    AppEvents["DOC_AI_COMPLETION"] = "doc.ai.completion";
    AppEvents["DOCUMENT_CREATE"] = "document.create";
    AppEvents["DOCUMENT_UPDATE"] = "document.update";
    AppEvents["DOCUMENT_DELETE"] = "document.delete";
    AppEvents["DOCUMENT_USER_MENTION"] = "document.user.mention";
    AppEvents["DOCUMENT_PUBLIC_SHARE_CREATE"] = "document.public_share.create";
    AppEvents["DOCUMENT_PUBLIC_SHARE_UPDATE"] = "document.public_share.update";
    AppEvents["DOCUMENT_PUBLIC_SHARE_DELETE"] = "document.public_share.delete";
    AppEvents["DOCUMENT_COMMENT_CREATE"] = "document.comment.create";
    AppEvents["DOCUMENT_COMMENT_UPDATE"] = "document.comment.update";
    AppEvents["DOCUMENT_COMMENT_DELETE"] = "document.comment.delete";
    AppEvents["DATE_DEPENDENCY_UPDATE"] = "date_dependency.update";
    AppEvents["DATE_DEPENDENCY_DELETE"] = "date_dependency.delete";
    AppEvents["RECORDS_SOFT_DELETE"] = "records.soft.delete";
    AppEvents["RECORDS_RESTORE"] = "records.restore";
    AppEvents["RECORDS_PERMANENT_DELETE"] = "records.permanent.delete";
    AppEvents["RESOURCE_RESTORE"] = "resource.restore";
    AppEvents["RESOURCE_PERMANENT_DELETE"] = "resource.permanent_delete";
    AppEvents["BASE_VARIABLE_CREATE"] = "baseVariable.create";
    AppEvents["BASE_VARIABLE_UPDATE"] = "baseVariable.update";
    AppEvents["BASE_VARIABLE_DELETE"] = "baseVariable.delete";
    AppEvents["MANAGED_APP_CREATE"] = "managedApp.create";
    AppEvents["MANAGED_APP_UPDATE"] = "managedApp.update";
    AppEvents["MANAGED_APP_DELETE"] = "managedApp.delete";
    AppEvents["MANAGED_APP_PUBLISH"] = "managedApp.publish";
    AppEvents["MANAGED_APP_INSTALL"] = "managedApp.install";
    AppEvents["MANAGED_APP_UPDATE_START"] = "managedApp.update.start";
    AppEvents["MANAGED_APP_UPDATE_COMPLETE"] = "managedApp.update.complete";
    AppEvents["MANAGED_APP_UPDATE_FAIL"] = "managedApp.update.fail";
})(AppEvents || (AppEvents = {}));
export var ClickhouseTables;
(function (ClickhouseTables) {
    ClickhouseTables["API_CALLS"] = "usage_api_calls";
    ClickhouseTables["API_COUNT"] = "usage_api_count";
    ClickhouseTables["NOTIFICATION"] = "nc_notification";
    ClickhouseTables["PAGE_SNAPSHOT"] = "docs_page_snapshot";
    ClickhouseTables["TELEMETRY"] = "usage_telemetry";
    ClickhouseTables["AUDIT"] = "nc_audit";
})(ClickhouseTables || (ClickhouseTables = {}));
export var WorkspaceStatus;
(function (WorkspaceStatus) {
    WorkspaceStatus[WorkspaceStatus["CREATING"] = 0] = "CREATING";
    WorkspaceStatus[WorkspaceStatus["CREATED"] = 1] = "CREATED";
    WorkspaceStatus[WorkspaceStatus["DELETING"] = 2] = "DELETING";
    WorkspaceStatus[WorkspaceStatus["DELETED"] = 3] = "DELETED";
    WorkspaceStatus[WorkspaceStatus["FAILED"] = 4] = "FAILED";
})(WorkspaceStatus || (WorkspaceStatus = {}));
export var WorkspacePlan;
(function (WorkspacePlan) {
    WorkspacePlan["FREE"] = "free";
    WorkspacePlan["TEAM"] = "team";
    WorkspacePlan["BUSINESS"] = "business";
})(WorkspacePlan || (WorkspacePlan = {}));
export const RoleLabels = {
    [WorkspaceUserRoles.OWNER]: 'owner',
    [WorkspaceUserRoles.CREATOR]: 'creator',
    [WorkspaceUserRoles.EDITOR]: 'editor',
    [WorkspaceUserRoles.COMMENTER]: 'commenter',
    [WorkspaceUserRoles.VIEWER]: 'viewer',
    [WorkspaceUserRoles.INHERIT]: 'inherit',
    [WorkspaceUserRoles.NO_ACCESS]: 'noaccess',
    [ProjectRoles.OWNER]: 'owner',
    [ProjectRoles.CREATOR]: 'creator',
    [ProjectRoles.EDITOR]: 'editor',
    [ProjectRoles.COMMENTER]: 'commenter',
    [ProjectRoles.VIEWER]: 'viewer',
    [ProjectRoles.INHERIT]: 'inherit',
    [ProjectRoles.NO_ACCESS]: 'noaccess',
    [OrgUserRoles.SUPER_ADMIN]: 'superAdmin',
    [OrgUserRoles.CREATOR]: 'creator',
    [OrgUserRoles.VIEWER]: 'viewer',
    [CloudOrgUserRoles.OWNER]: 'orgAdmin',
    [CloudOrgUserRoles.CREATOR]: 'orgCreator',
    [CloudOrgUserRoles.VIEWER]: 'orgViewer',
};
export const RoleColors = {
    [WorkspaceUserRoles.OWNER]: 'purple',
    [WorkspaceUserRoles.CREATOR]: 'blue',
    [WorkspaceUserRoles.EDITOR]: 'green',
    [WorkspaceUserRoles.COMMENTER]: 'orange',
    [WorkspaceUserRoles.VIEWER]: 'yellow',
    [WorkspaceUserRoles.INHERIT]: 'gray',
    [WorkspaceUserRoles.NO_ACCESS]: 'red',
    [ProjectRoles.OWNER]: 'purple',
    [ProjectRoles.CREATOR]: 'blue',
    [ProjectRoles.EDITOR]: 'green',
    [ProjectRoles.COMMENTER]: 'orange',
    [ProjectRoles.VIEWER]: 'yellow',
    [ProjectRoles.INHERIT]: 'gray',
    [OrgUserRoles.SUPER_ADMIN]: 'maroon',
    [ProjectRoles.NO_ACCESS]: 'red',
    [OrgUserRoles.CREATOR]: 'blue',
    [OrgUserRoles.VIEWER]: 'yellow',
    [CloudOrgUserRoles.OWNER]: 'purple',
    [CloudOrgUserRoles.CREATOR]: 'blue',
    [CloudOrgUserRoles.VIEWER]: 'yellow',
};
export const RoleDescriptions = {
    [WorkspaceUserRoles.OWNER]: 'Has full control over all workspace bases, settings, and billing',
    [WorkspaceUserRoles.CREATOR]: 'Can create, configure, and edit all bases within the workspace',
    [WorkspaceUserRoles.EDITOR]: 'Can add, edit, and delete records, but cannot modify base configurations',
    [WorkspaceUserRoles.COMMENTER]: 'Can view and comment on records within workspace bases',
    [WorkspaceUserRoles.VIEWER]: 'Can only view records within workspace bases',
    [WorkspaceUserRoles.INHERIT]: 'Inherits role from workspace-level team assignment',
    [WorkspaceUserRoles.NO_ACCESS]: 'No access to this workspace',
    [ProjectRoles.OWNER]: 'Has full control over the base, including configuration and deletion rights',
    [ProjectRoles.CREATOR]: 'Can fully configure the base but cannot delete it',
    [ProjectRoles.EDITOR]: 'Can add, edit, and delete records, but cannot modify base configurations',
    [ProjectRoles.COMMENTER]: 'Can view and comment on records within the base',
    [ProjectRoles.VIEWER]: 'Can only view records within the base',
    [ProjectRoles.INHERIT]: 'Inherits role from base-level team, or workspace level if no base-level team',
    [ProjectRoles.NO_ACCESS]: 'No access to this base',
    [OrgUserRoles.SUPER_ADMIN]: 'Full access to all',
    [OrgUserRoles.CREATOR]: 'Can fully configure and edit bases',
    [OrgUserRoles.VIEWER]: 'Can only view records in bases',
    [CloudOrgUserRoles.OWNER]: 'Full access to organization and workspaces',
    [CloudOrgUserRoles.CREATOR]: 'Can create and manage domains, users and workspaces',
    [CloudOrgUserRoles.VIEWER]: 'Can only view organization and workspaces',
};
export const RoleIcons = {
    [WorkspaceUserRoles.OWNER]: 'role_owner',
    [WorkspaceUserRoles.CREATOR]: 'role_creator',
    [WorkspaceUserRoles.EDITOR]: 'role_editor',
    [WorkspaceUserRoles.COMMENTER]: 'role_commenter',
    [WorkspaceUserRoles.VIEWER]: 'role_viewer',
    [WorkspaceUserRoles.INHERIT]: 'role_inherit',
    [WorkspaceUserRoles.NO_ACCESS]: 'role_no_access',
    [ProjectRoles.OWNER]: 'role_owner',
    [ProjectRoles.CREATOR]: 'role_creator',
    [ProjectRoles.EDITOR]: 'role_editor',
    [ProjectRoles.COMMENTER]: 'role_commenter',
    [ProjectRoles.VIEWER]: 'role_viewer',
    [ProjectRoles.INHERIT]: 'role_inherit',
    [ProjectRoles.NO_ACCESS]: 'role_no_access',
    [OrgUserRoles.SUPER_ADMIN]: 'role_super',
    [OrgUserRoles.CREATOR]: 'role_creator',
    [OrgUserRoles.VIEWER]: 'role_viewer',
    [CloudOrgUserRoles.OWNER]: 'role_owner',
    [CloudOrgUserRoles.CREATOR]: 'role_creator',
    [CloudOrgUserRoles.VIEWER]: 'role_viewer',
};
export const WorkspaceRolesToProjectRoles = {
    [WorkspaceUserRoles.OWNER]: ProjectRoles.OWNER,
    [WorkspaceUserRoles.CREATOR]: ProjectRoles.CREATOR,
    [WorkspaceUserRoles.EDITOR]: ProjectRoles.EDITOR,
    [WorkspaceUserRoles.COMMENTER]: ProjectRoles.COMMENTER,
    [WorkspaceUserRoles.VIEWER]: ProjectRoles.VIEWER,
    [WorkspaceUserRoles.NO_ACCESS]: ProjectRoles.NO_ACCESS,
    [WorkspaceUserRoles.INHERIT]: ProjectRoles.INHERIT,
};
export const OrderedWorkspaceRoles = [
    WorkspaceUserRoles.OWNER,
    WorkspaceUserRoles.CREATOR,
    WorkspaceUserRoles.INHERIT,
    WorkspaceUserRoles.EDITOR,
    WorkspaceUserRoles.COMMENTER,
    WorkspaceUserRoles.VIEWER,
    WorkspaceUserRoles.NO_ACCESS,
];
export const OrderedOrgRoles = [
    OrgUserRoles.SUPER_ADMIN,
    OrgUserRoles.CREATOR,
    OrgUserRoles.VIEWER,
];
export const OrderedProjectRoles = [
    ProjectRoles.OWNER,
    ProjectRoles.CREATOR,
    ProjectRoles.INHERIT,
    ProjectRoles.EDITOR,
    ProjectRoles.COMMENTER,
    ProjectRoles.VIEWER,
    ProjectRoles.NO_ACCESS,
];
export var APIContext;
(function (APIContext) {
    APIContext["VIEW_COLUMNS"] = "fields";
    APIContext["FILTERS"] = "filters";
    APIContext["SORTS"] = "sorts";
})(APIContext || (APIContext = {}));
export var SourceRestriction;
(function (SourceRestriction) {
    SourceRestriction["SCHEMA_READONLY"] = "is_schema_readonly";
    SourceRestriction["DATA_READONLY"] = "is_data_readonly";
})(SourceRestriction || (SourceRestriction = {}));
export var ClientType;
(function (ClientType) {
    ClientType["MYSQL"] = "mysql2";
    ClientType["PG"] = "pg";
    ClientType["SQLITE"] = "sqlite3";
    ClientType["VITESS"] = "vitess";
    ClientType["SNOWFLAKE"] = "snowflake";
    ClientType["DATABRICKS"] = "databricks";
})(ClientType || (ClientType = {}));
export var SSLUsage;
(function (SSLUsage) {
    SSLUsage["No"] = "No";
    SSLUsage["Allowed"] = "Allowed";
    SSLUsage["Preferred"] = "Preferred";
    SSLUsage["Required"] = "Required";
    SSLUsage["RequiredWithCa"] = "Required-CA";
    SSLUsage["RequiredWithIdentity"] = "Required-Identity";
})(SSLUsage || (SSLUsage = {}));
export var SyncDataType;
(function (SyncDataType) {
    // Database
    SyncDataType["NOCODB"] = "nocodb";
    SyncDataType["MICROSOFT_ACCESS"] = "microsoft-access";
    SyncDataType["TABLEAU"] = "tableau";
    // AI
    SyncDataType["OPENAI"] = "openai";
    SyncDataType["CLAUDE"] = "claude";
    SyncDataType["OLLAMA"] = "ollama";
    SyncDataType["GROQ"] = "groq";
    // Communication
    SyncDataType["SLACK"] = "slack";
    SyncDataType["DISCORD"] = "discord";
    SyncDataType["TWILLO"] = "twillo";
    SyncDataType["MICROSOFT_OUTLOOK"] = "microsoft-outlook";
    SyncDataType["MICROSOFT_TEAMS"] = "microsoft-teams";
    SyncDataType["TELEGRAM"] = "telegram";
    SyncDataType["GMAIL"] = "gmail";
    SyncDataType["WHATSAPP"] = "whatsapp";
    // Project Management
    SyncDataType["ASANA"] = "asana";
    SyncDataType["JIRA"] = "jira";
    SyncDataType["MIRO"] = "miro";
    SyncDataType["TRELLO"] = "trello";
    // CRM
    SyncDataType["SALESFORCE"] = "salesforce";
    SyncDataType["PIPEDRIVE"] = "pipedrive";
    SyncDataType["MICROSOFT_DYNAMICS_365"] = "microsoft-dynamics-365";
    SyncDataType["ZOHO_CRM"] = "zoho-crm";
    // Marketing
    SyncDataType["HUBSPOT"] = "hubspot";
    SyncDataType["MAILCHIMP"] = "mailchimp";
    SyncDataType["SURVEYMONKEY"] = "surveymonkey";
    SyncDataType["TYPEFORM"] = "typeform";
    // ATS
    SyncDataType["WORKDAY"] = "workday";
    SyncDataType["GREENHOUSE"] = "greenhouse";
    SyncDataType["LEVER"] = "lever";
    // Development
    SyncDataType["GITHUB"] = "github";
    SyncDataType["GITLAB"] = "gitlab";
    SyncDataType["BITBUCKET"] = "bitbucket";
    // Finance
    SyncDataType["STRIPE"] = "stripe";
    SyncDataType["QUICKBOOKS"] = "quickbooks";
    // Ticketing
    SyncDataType["FRESHDESK"] = "freshdesk";
    SyncDataType["INTERCOM"] = "intercom";
    SyncDataType["ZENDESK"] = "zendesk";
    SyncDataType["HUBSPOT_SERVICE_HUB"] = "hubspot-service-hub";
    SyncDataType["SALESFORCE_SERVICE_CLOUD"] = "salesforce-service-cloud";
    // Storage
    SyncDataType["BOX"] = "box";
    SyncDataType["GOOGLE_DRIVE"] = "google-drive";
    SyncDataType["DROPBOX"] = "dropbox";
    // Others
    SyncDataType["APPLE_NUMBERS"] = "apple-numbers";
    SyncDataType["GOOGLE_CALENDAR"] = "google-calendar";
    SyncDataType["MICROSOFT_EXCEL"] = "microsoft-excel";
    SyncDataType["GOOGLE_SHEETS"] = "google-sheets";
})(SyncDataType || (SyncDataType = {}));
export var IntegrationCategoryType;
(function (IntegrationCategoryType) {
    IntegrationCategoryType["DATABASE"] = "database";
    IntegrationCategoryType["AI"] = "ai";
    IntegrationCategoryType["COMMUNICATION"] = "communication";
    IntegrationCategoryType["SPREAD_SHEET"] = "spread-sheet";
    IntegrationCategoryType["PROJECT_MANAGEMENT"] = "project-management";
    IntegrationCategoryType["CRM"] = "crm";
    IntegrationCategoryType["MARKETING"] = "marketing";
    IntegrationCategoryType["ATS"] = "ats";
    IntegrationCategoryType["DEVELOPMENT"] = "development";
    IntegrationCategoryType["FINANCE"] = "finance";
    IntegrationCategoryType["TICKETING"] = "ticketing";
    IntegrationCategoryType["STORAGE"] = "storage";
    IntegrationCategoryType["OTHERS"] = "others";
    IntegrationCategoryType["SYNC"] = "sync";
    IntegrationCategoryType["AUTH"] = "auth";
})(IntegrationCategoryType || (IntegrationCategoryType = {}));
export var ViewLockType;
(function (ViewLockType) {
    ViewLockType["Personal"] = "personal";
    ViewLockType["Locked"] = "locked";
    ViewLockType["Collaborative"] = "collaborative";
})(ViewLockType || (ViewLockType = {}));
export var PublicAttachmentScope;
(function (PublicAttachmentScope) {
    PublicAttachmentScope["WORKSPACEPICS"] = "workspacePics";
    PublicAttachmentScope["PROFILEPICS"] = "profilePics";
    PublicAttachmentScope["ORGANIZATIONPICS"] = "organizationPics";
    PublicAttachmentScope["OAUTHCLIENTS"] = "oauthClients";
})(PublicAttachmentScope || (PublicAttachmentScope = {}));
export var IconType;
(function (IconType) {
    IconType["IMAGE"] = "IMAGE";
    IconType["EMOJI"] = "EMOJI";
    IconType["ICON"] = "ICON";
})(IconType || (IconType = {}));
export var NcApiVersion;
(function (NcApiVersion) {
    NcApiVersion[NcApiVersion["V1"] = 0] = "V1";
    NcApiVersion[NcApiVersion["V2"] = 1] = "V2";
    NcApiVersion[NcApiVersion["V3"] = 2] = "V3";
})(NcApiVersion || (NcApiVersion = {}));
export var HookOperationCode;
(function (HookOperationCode) {
    HookOperationCode[HookOperationCode["insert"] = 1] = "insert";
    HookOperationCode[HookOperationCode["update"] = 2] = "update";
    HookOperationCode[HookOperationCode["delete"] = 4] = "delete";
    HookOperationCode[HookOperationCode["trigger"] = 8] = "trigger";
})(HookOperationCode || (HookOperationCode = {}));
export var WebhookActions;
(function (WebhookActions) {
    WebhookActions["INSERT"] = "insert";
    WebhookActions["UPDATE"] = "update";
    WebhookActions["DELETE"] = "delete";
})(WebhookActions || (WebhookActions = {}));
export var WebhookEvents;
(function (WebhookEvents) {
    WebhookEvents["AFTER"] = "after";
    WebhookEvents["BEFORE"] = "before";
    WebhookEvents["MANUAL"] = "manual";
    WebhookEvents["VIEW"] = "view";
    WebhookEvents["FIELD"] = "field";
})(WebhookEvents || (WebhookEvents = {}));
export var ViewSettingOverrideOptions;
(function (ViewSettingOverrideOptions) {
    ViewSettingOverrideOptions["FIELD_VISIBILITY"] = "fieldVisibility";
    ViewSettingOverrideOptions["FIELD_ORDER"] = "fieldOrder";
    ViewSettingOverrideOptions["COLUMN_WIDTH"] = "columnWidth";
    ViewSettingOverrideOptions["ROW_HEIGHT"] = "rowHeight";
    ViewSettingOverrideOptions["FILTER_CONDITION"] = "filterCondition";
    ViewSettingOverrideOptions["SORT"] = "sort";
    ViewSettingOverrideOptions["GROUP"] = "group";
    ViewSettingOverrideOptions["ROW_COLORING"] = "rowColoring";
})(ViewSettingOverrideOptions || (ViewSettingOverrideOptions = {}));
export var MetaEventType;
(function (MetaEventType) {
    MetaEventType["COLUMN_ADDED"] = "COLUMN_ADDED";
    MetaEventType["COLUMN_UPDATED"] = "COLUMN_UPDATED";
    MetaEventType["COLUMN_DELETED"] = "COLUMN_DELETED";
    MetaEventType["HOOK_DELETED"] = "HOOK_DELETED";
})(MetaEventType || (MetaEventType = {}));
export var MetaEntityType;
(function (MetaEntityType) {
    MetaEntityType["BASE"] = "BASE";
    MetaEntityType["TABLE"] = "TABLE";
    MetaEntityType["COLUMN"] = "COLUMN";
    MetaEntityType["VIEW"] = "VIEW";
    MetaEntityType["FILTER"] = "FILTER";
    MetaEntityType["SORT"] = "SORT";
    MetaEntityType["VIEW_ROW_COLOR"] = "VIEW_ROW_COLOR";
})(MetaEntityType || (MetaEntityType = {}));
export var MapProvider;
(function (MapProvider) {
    MapProvider["OPENSTREETMAP"] = "openstreetmap";
    MapProvider["STADIAMAP"] = "stadiamap";
    MapProvider["STADIAMAP_APIKEY"] = "stadiamap_apikey";
})(MapProvider || (MapProvider = {}));
/** Default org ID for on-prem deployments */
export const NC_DEFAULT_ORG_ID = 'org_default';
export var OperationSource;
(function (OperationSource) {
    OperationSource["AT_IMPORT"] = "at_import";
    OperationSource["HOOKS"] = "hooks";
    OperationSource["EXTERNAL_DBS"] = "external_dbs";
    OperationSource["ATTACHMENTS"] = "attachments";
    OperationSource["SSO"] = "sso";
    OperationSource["MIGRATION"] = "migration";
    OperationSource["WORKFLOW"] = "workflow";
    OperationSource["PLUGINS"] = "plugins";
})(OperationSource || (OperationSource = {}));
//# sourceMappingURL=data:application/json;base64,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